import * as ActivateUtrTypes from './activate-utr-types';
import * as ClubActionTypes from './club-action-types';
import * as ComponentConfigActions from './component-config-action-types';
import * as CourtSchedulerTypes from './court-scheduler-types';
import * as EventActionTypes from './event-action-types';
import * as EventTemplateActionTypes from './event-template-action-types';
import * as MenuActionTypes from './menu-action-types';
import * as NextAvailableTypes from './next-available-types';
import * as ProgressBarActions from './progress-bar-action-types';
import * as SearchActionTypes from './search-action-types';
import * as SettingActionTypes from './setting-action-types';

const actionTypes = {
    ...ProgressBarActions,
    ...ComponentConfigActions,
    ...MenuActionTypes,
    ...EventActionTypes,
    ...EventTemplateActionTypes,
    ...ClubActionTypes,
    ...SettingActionTypes,
    ...ActivateUtrTypes,
    ...CourtSchedulerTypes,
    ...NextAvailableTypes,
    ...SearchActionTypes,
};

export default actionTypes;
